import {PriceChangeDirection} from "../types/PriceChangeDirection";
import {IPropertyListProperty} from "../types/PropertyListProperty";

export type PropertyBadgeType = "reservation" | "promotion" | "price_decreased" | "recommended";

export function getPropertyBadgeType(property: IPropertyListProperty): PropertyBadgeType | null {
    //  TODO: Add source for isRecommended or remove this case if there is a business decisoin to drop it
    const isRecommended = false;

    if (property.is_reserved) {
        return "reservation";
    }

    if (property.is_promo) {
        return "promotion";
    }

    if (property.price_change_direction === PriceChangeDirection.PRICE_DECREASED) {
        return "price_decreased";
    }

    if (isRecommended) {
        return "recommended";
    }

    return null;
}
import {PriceChangeDirection} from "../types/PriceChangeDirection";
import {IPropertyListProperty} from "../types/PropertyListProperty";

export type PropertyBadgeType = "reservation" | "promotion" | "price_decreased" | "recommended";

export function getPropertyBadgeType(property: IPropertyListProperty): PropertyBadgeType | null {
    //  TODO: Add source for isRecommended or remove this case if there is a business decisoin to drop it
    const isRecommended = false;

    if (property.is_reserved) {
        return "reservation";
    }

    if (property.is_promo) {
        return "promotion";
    }

    if (property.price_change_direction === PriceChangeDirection.PRICE_DECREASED) {
        return "price_decreased";
    }

    if (isRecommended) {
        return "recommended";
    }

    return null;
}
